/**
 * 图片地址
 * Filename: image.js
 * Author: GaoYu
 * Time: 2020/8/4 9:42
 */

const aliOssDomain = 'http://dianyuan-public.oss-cn-shenzhen.aliyuncs.com/static'

const actImg = aliOssDomain + '/live_H5/huodong.png'

export {
  actImg
}



// WEBPACK FOOTER //
// ./src/utils/image.js